package co.maytes.standupbot.dashboard.init

import co.maytes.standupbot.dashboard.lib.config.AppConfig

private external interface SentryModule {
    fun init(options: dynamic)

    fun captureMessage(message: String)
}

@JsModule("@sentry/browser")
@JsNonModule
private external val sentry: SentryModule

@JsModule("web-vitals")
@JsNonModule
private external val webVitals: dynamic

private var initialized = false

fun initFrontendObservability() {
    if (initialized) return
    val dsn = AppConfig.SENTRY_DSN
    if (dsn.isBlank()) return
    initialized = true

    val options: dynamic = js("{}")
    options.dsn = dsn
    options.environment = AppConfig.ENV
    options.release = AppConfig.SENTRY_RELEASE
    options.sendDefaultPii = false
    options.tracesSampleRate = 0.0
    sentry.init(options)

    val report: (dynamic) -> Unit = { metric ->
        val name = metric.name as String
        val value = (metric.value as Double).toString()
        val rating = metric.rating as String
        sentry.captureMessage("web-vital $name=$value rating=$rating")
    }
    webVitals.onCLS(report)
    webVitals.onLCP(report)
    webVitals.onINP(report)
    webVitals.onFCP(report)
    webVitals.onTTFB(report)
}
